import { timeout, delay } from '@ynap/promise-utils';
import { ResponseError, Person } from '@ynap/api-utils';
import { UPDATE_USER_REQUEST, UPDATE_USER_SUCCESS, UPDATE_USER_ERROR } from '../constants/ActionTypes';
import setUpdateUserSuccess from './setUpdateUserSuccess';
import { push } from 'connected-react-router';

const EMAIL_CONSENT_ATTRIBUTE_NAMES = ['maMarketingConsent', 'maMarketingEmailStandard'];

function updateUserInfoRequest() {
    return {
        type: UPDATE_USER_REQUEST,
    };
}

function updateUserInfoSuccess(user) {
    return {
        type: UPDATE_USER_SUCCESS,
        body: user,
    };
}

function updateUserInfoError(error) {
    return {
        type: UPDATE_USER_ERROR,
        error,
    };
}

export default function updateUserInfo(user, extraAttributes = {}) {
    return (dispatch, getState, fetch) => {
        const { uberToken, locale, config, user: userFromStore, router } = getState();
        const { country } = locale;
        const { location = {} } = router;
        const { pathname } = location;
        const { clientRequest } = config.head || config;
        const { baseUrl, clientId, clientSecret } = config.watsonService || config.global.services.commerce;
        const { brandId } = config.watsonService || config.global.application;

        const { dateOfBirthGroup, ...rest } = user;
        const { day, month, year } = dateOfBirthGroup || {};
        const dobForStore = day && month ? `${year ? year : '1900'}-${month}-${day}T00:00:00.0Z` : '';
        const dobForAPI = day && month ? `${day}-${month}-${year ? year : '1900'}` : '';

        const userForAPI = { ...rest };
        const userForStore = { ...rest };

        if (user.hasOwnProperty('dateOfBirthGroup')) {
            userForAPI.dateOfBirth = dobForAPI;
            userForStore.dateOfBirth = dobForStore;
        }

        if (extraAttributes.hasOwnProperty('emailMarketingConsent')) {
            const value = extraAttributes.emailMarketingConsent ? 'true' : 'false';

            userForAPI.contextAttribute = EMAIL_CONSENT_ATTRIBUTE_NAMES.map((attributeName) => ({
                attributeName,
                attributeValue: { value },
            }));

            userForStore.contextAttribute = userFromStore.contextAttribute.map((attr) => {
                if (!EMAIL_CONSENT_ATTRIBUTE_NAMES.includes(attr.attributeName)) {
                    return attr;
                }

                return { ...attr, attributeValue: [{ ...attr.attributeValue[0], value: [value] }] };
            });
        }

        const request = Person.userUpdate({
            baseUrl,
            brandId,
            country,
            user: userForAPI,
            uberToken,
            clientId,
            clientSecret,
            options: locale.langISO ? { locale: locale.langISO } : undefined,
        });

        dispatch(updateUserInfoRequest());

        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok, status } = response;

                if (ok) {
                    return response
                        .json()
                        .then(() => dispatch(updateUserInfoSuccess(userForStore)))
                        .then(() => dispatch(setUpdateUserSuccess('personalInfo')));
                } else if (status === 401) {
                    return dispatch(push(`/${locale.id}/account/login?redirect=${pathname}`));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(updateUserInfoError(error));
                throw error;
            });
    };
}
